import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const testimonialsCarousel = () => {
  const sliders = document.querySelectorAll('.customer-testimonials');
  if (!sliders) return;

  sliders?.forEach((slider) => {
    const swiperOptions = {
      navigation: {
        nextEl: '.customer-testimonial-navigation.swiper-btn-next',
        prevEl: '.customer-testimonial-navigation.swiper-btn-prev',
      },
      speed: 400,
      spaceBetween: 12,
      slidesPerView: 4,
      slidesOffsetAfter: 12,
      breakpoints: {
        1536: {
          slidesPerView: 2.8444,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 2.7,
          spaceBetween: 16,
        },
        900: {
          slidesPerView: 1.7,
        },
        600: {
          slidesPerView: 1.5,
        },
        320: {
          slidesPerView: 1.37865,
          spaceBetween: 16,
        },
      },
    };

    new Swiper(slider, swiperOptions);
  });
};
